import { render, staticRenderFns } from "./EditBudget.vue?vue&type=template&id=5b7e54fe&"
import script from "./EditBudget.vue?vue&type=script&lang=js&"
export * from "./EditBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports